import { MAX_INPUT_LIMIT, PATTERN_VALIDATION_TYPES } from "../../../utilities/constants"

export const tableGroupValueIdKey = "__id"

export const FIELD_GROUP_TYPES = {
  FIELDS: "FIELDS",
  LIST: "LIST",
  TABLE: "TABLE",
  // Bespoke controlled roster table (Step-2 Players / Observers). Same Formik
  // value/validation contract as TABLE (array of row objects), but rendered by
  // RosterTable to pixel-match the flattened mock instead of the MUI DataGrid.
  ROSTER: "ROSTER",
}

export const FIELD_TYPES = {
  DATE: "DATE",
  TIME: "TIME",
  STRING: "STRING",
  ROLE_INPUT: "ROLE_INPUT", // Free-text role field + <datalist> suggestions; value is a STRING. "" / "All roles" == whole incident. Server resolves the typed role to a scenario role.
  EMAIL: "EMAIL",
  NUMBER: "NUMBER",
  DROPDOWN: "DROPDOWN",
  MULTI_DROPDOWN: "MULTI_DROPDOWN", // Multi-select dropdown (checkbox popover); value is string[], [] == "All". Works in flat form + roster cells.
  OPTIONS: "OPTIONS", // Radio Button List (Single Select)
  OPTION_CARDS: "OPTION_CARDS", // Single-select rich card list (title/badge/subtitle/description)
  MULTI_OPTIONS: "MULTI_OPTIONS", // Checkboxes List (Multi-Select)
  OPTIONS_WITH_STRING_OTHER: "OPTIONS_WITH_STRING_OTHER",
  MULTI_OPTIONS_WITH_STRING_OTHER: "MULTI_OPTIONS_WITH_STRING_OTHER",
  ACTION_BTN: "ACTION_BTN",
  FILE: "FILE",
  FACILITATOR_TOGGLE: "FACILITATOR_TOGGLE", // Direct checkbox in TABLE columns — no inline-edit portal; MULTI-select (co-equal facilitators)
  PERSON_BOT_SWITCH: "PERSON_BOT_SWITCH", // Roster "Played by": person⇄bot icon switch; on ⇒ a bot picker (options) selects which bot. Stored value: "human" | <botKey>
}

export const VALIDATION_TYPES = {
  SAFETEXT: "SAFETEXT",
  SAFENAME: "SAFENAME",
  SAFE_API_NODE_NAME: "SAFE_API_NODE_NAME",
  REQUIRED: "REQUIRED",
  EMAIL: "EMAIL",
  NUMBER_MIN: "NUMBER_MIN",
  NUMBER_MAX: "NUMBER_MAX",
  MAX_LENGTH: "MAX_LENGTH",
  MIN_LENGTH: "MIN_LENGTH",
  FUTURE_DATETIME: "FUTURE_DATETIME",
  MAX_FILE_SIZE: "MAX_FILE_SIZE",
  VALID_FILE_EXTENSIONS: "VALID_FILE_EXTENSIONS",
  VALID_PLAYER_LIST_CSV: "VALID_PLAYER_LIST_CSV",
  UNIQUE: "UNIQUE",
}

export const MAX_ALLOWED_FILE_SIZE_BYTES = 1 * 1024 * 1024 // 1MB

export const MAX_LENGTH_VALIDATION_DEFAULT_VALUE = MAX_INPUT_LIMIT

export const MIN_LENGTH_VALIDATION_DEFAULT_VALUE = 1

export const MIN_ARRAY_LENGTH_VALIDATION_DEFAULT_VALUE = 1
export const MAX_ARRAY_LENGTH_VALIDATION_DEFAULT_VALUE = 50

export const LAYOUT_TYPES = {
  LAYOUT_1_COLUMN: "1-COLUMN",
  LAYOUT_2_COLUMN: "2-COLUMN",
}

export const OTHER_OPTION_PLACEHOLDER_VALUE = "Other"

export const OTHER_OPTION_VALIDATION_ERROR_MESSAGE = `An 'Other' value is required.`

// Validator Constants
export const validNameFieldMatchRegex = /^[-a-zA-ZÀ-ÖØ-öø-ÿ0-9 _@+.,'"/!&()]+$/
export const validNameFieldMaxLength = 128
export const validNameErrorMessage = `Value contains invalid characters. Only letters, numbers, spaces and _ @ + . , ' " / ! & ( ) allowed.`

// Free-text entries share the canonical SAFE_TEXT charset (utilities/constants) — this was a
// drifted local copy missing the 2026-09 widening (# % = ~ ^ { } | and em-dash), so gameplay
// input and Other-option text rejected characters the scenario forms accepted.
// Server lockstep: validTextEntryMatchRegex / invalidTextEntryMatchRegex in server/server.js.
export const validTextEntryMatchRegex = PATTERN_VALIDATION_TYPES.SAFE_TEXT
export const validTextErrorMessage = `Value contains invalid characters. < and > are not allowed.`
export const emailValidationOptions = {
  allow_display_name: false,
  require_display_name: false,
  allow_utf8_local_part: true,
  require_tld: true,
  allow_ip_domain: false,
  allow_underscores: true,
  domain_specific_validation: false,
  blacklisted_chars: "",
  host_blacklist: [],
}

// Unified with PATTERN_VALIDATION_TYPES.SAFE_NAME (utilities/constants) 2026-09-03 so exercise
// names accept the same characters as scenario display names. Excluded for transport/security
// only: / (encoded %2F is re-decoded and re-split by nginx/Hasura path parsers), \, < >
// (server <token> substitution + HTML), and newlines. Server lockstep: server/server.js
// validAPINodeEntryMatchRegex in chaos-player-poc.
export const validAPINodeEntryMatchRegex = PATTERN_VALIDATION_TYPES.SAFE_NAME
export const validAPINodeErrorMessage = `Name contains invalid characters. / \\ < > and line breaks are not allowed.`
export const validAPINodeFieldMaxLength = 128
